export default "__VITE_ASSET__BAZupCjh__"